import { ClientComponents } from "trader.ts";
import * as planning_start_public_main from "../pages/planning_start_public/client";
import * as messagequeue_client from "../pages/messagequeue/client";
import * as editemailtemplates_client from "../pages/editemailtemplates/client";
//$PLACEHOLDER1
import * as enrollments_filters_advanced_client from "../pages/enrollments_filters_advanced/client";
import * as admin_dashboard_client from "../pages/admin_dashboard/client";
import * as student_charges_client from "../pages/student_charges/client";
import * as lessongroup_mutuality_certificates_client from "../pages/lessongroup_mutuality_certificates/client";
import * as mutuality_certificate_config_client from "../pages/mutuality_certificate_config/client";
import * as student_start_links_client from "../pages/student_start_links/client";
import * as config_student_links_client from "../pages/config_student_links/client";
import * as config_teacher_links_client from "../pages/config_teacher_links/client";
import * as config_overview_client from "../pages/config_overview/client";
import * as finance_payments_overview_client from "../pages/finance_payments_overview/client";
import * as config_public_enrollments_client from "../pages/config_public_enrollments/client";
import * as third_party_seller_students_client from "../pages/third_party_seller_students/client";
import * as student_start_messages_client from "../pages/student_start_messages/client";
import * as student_start_evaluations_client from "../pages/student_start_evaluations/client";
import * as student_start_absences_client from "../pages/student_start_absences/client";
import * as student_start_lessons_notes_client from "../pages/student_start_lessons_notes/client";
import * as third_party_seller_edit_client from "../pages/third_party_seller_edit/client";
import * as third_party_sellers_client from "../pages/third_party_sellers/client";
import * as student_merge_client from "../pages/student_merge/client";
import * as student_direct_debit_mandates_client from "../pages/student_direct_debit_mandates/client";
import * as config_invoice_pdf_client from "../pages/config_invoice_pdf/client";
import * as config_evaluation_pdf_client from "../pages/config_evaluation_pdf/client";
import * as evaluation_missing_list_client from "../pages/evaluation_missing_list/client";
import * as reenrollment_batches_client from "../pages/reenrollment_batches/client";
import * as audit_log_overview_client from "../pages/audit_log_overview/client";
import * as payment_detail_client from "../pages/payment_detail/client";
import * as evaluation_list_client from "../pages/evaluation_list/client";
import * as evaluation_template_client from "../pages/evaluation_template/client";
import * as evaluation_templates_list_client from "../pages/evaluation_templates_list/client";
import * as failed_enrollment_requests_client from "../pages/failed_enrollment_requests/client";
import * as lessongroup_questions_edit_client from "../pages/lessongroup_questions_edit/client";
import * as payment_schemes_client from "../pages/payment_schemes/client";
import * as lessongroup_questions_client from "../pages/lessongroup_questions/client";
import * as waitinglist_admin_lessongroup_client from "../pages/waitinglist_admin_lessongroup/client";
import * as waitinglist_student_client from "../pages/waitinglist_student/client";
import * as waitinglist_admin_client from "../pages/waitinglist_admin/client";
import * as statistics_enrollments_client from "../pages/statistics_enrollments/client";
import * as reset_password_client from "../pages/reset_password/client";
import * as login_client from "../pages/login/client";
import * as config_mollie_client from "../pages/config_mollie/client";
import * as config_schoolconfig_client from "../pages/config_schoolconfig/client";
import * as lessons_now_or_soon_client from "../pages/lessons_now_or_soon/client";
import * as lesson_statistics_client from "../pages/lesson_statistics/client";
import * as profile_client from "../pages/profile/client";
import * as emailsettings_client from "../pages/emailsettings/client";
import * as welcome_client from "../pages/welcome/client";
import * as help_client from "../pages/help/client";
import * as teacher_edit_client from "../pages/teacher_edit/client";
import * as invoicesToReimburse_client from "../pages/invoices_to_reimburse/client";
import * as student_advanced_client from "../pages/student_advanced/client";
import * as lessongroup_lessondata_client from "../pages/lessongroup_lessondata/client";
import * as evaluation_edit_client from "../pages/evaluation_edit/client";
import * as site_edit_client from "../pages/site_edit/client";
import * as lessongroup_general_client from "../pages/lessongroup_general/client";
import * as student_list_client from "../pages/student_list/client";
import * as roomedit_client from "../pages/roomedit/client";
import * as tenantinvoices_client from "../pages/tenantinvoices/client";
import * as config_instruments_client from "../pages/config_instruments/client";
import * as adminaccounts_client from "../pages/adminaccounts/client";
import * as studentedit_client from "../pages/studentedit/client";
import * as search_client from "../pages/search/client";
import * as periodsconfig_client from "../pages/periodsconfig/client";
import * as payments_overview_periodic_client from "../pages/payments_overview_periodic/client";
import * as payinvoice_client from "../pages/payinvoice/client";
import * as payments_overview_non_periodic_client from "../pages/payments_overview_non_periodic/client";
import * as finance_invoices_client from "../pages/finance_invoices/client";
import * as deletestudent_client from "../pages/deletestudent/client";
import * as student_financial_client from "../pages/student_financial/client";
import * as public_new_enrollment_client from "../pages/public_new_enrollment/client";
import * as invoicedetails_client from "../pages/invoicedetails/client";
import * as config_financial_client from "../pages/config_financial/client";
import * as config_formulas_client from "../pages/config_formulas/client";
import * as student_profile_client from "../pages/student_profile/client";
import * as yearcalendar_client from "../pages/yearcalendar/client";
import * as student_start_client from "../pages/student_start/client";
import * as reenroll_invitation_client from "../pages/reenroll_invitation/client";
import * as reenrollments_client from "../pages/reenrollments/client";
import * as roomplanning_client from "../pages/roomplanning/client";
import * as studentoverview_client from "../pages/studentoverview/client";
import * as teacher_lessonroster_client from "../pages/teacher_lessonroster/client";
import * as teacher_students_client from "../pages/teacher_students/client";
import * as planning_client from "../pages/planning/client";
import * as approve_enrollment_request_client from "../pages/approve_enrollment_request/client";
import * as notes_client from "../pages/notes/client";
import * as messages_client from "../pages/messages/client";
import * as erroremails_client from "../pages/erroremails/client";
import * as editevent_client from "../pages/editevent/client";
import * as editmessageonstudentprofiles_client from "../pages/editmessageonstudentprofiles/client";
import * as groupmessage_client from "../pages/groupmessage/client";
import * as absences_to_approve_list_client from "../pages/absences_to_approve_list/client";
import { registerArrayMethods } from "../lib/arraymethods";
import { registerUncaughtErrorReporter } from "../pages/uncaughterror/client";

registerArrayMethods();

registerUncaughtErrorReporter();

// Cleaning up logs:
// https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb
/* eslint-disable */
if (!(window as any).__gCrWeb) {
  (window as any)["__gCrWeb"] = {};
}
/* eslint-enable */

export const client = ClientComponents.registerClientComponentsSync({
  // landingpage_democomponent: async () => {
  //   const modu = await import("./landingpage_democomponent");
  //   return modu.render;
  // },
  planning_start_public_main: planning_start_public_main.render,
  // landingpage_makenewinvoice: landingpage_makenewinvoice.render,
  messagequeue_client: messagequeue_client.render,
  messagequeue_detail_client: messagequeue_client.renderDetail,
  editemailtemplates_client: editemailtemplates_client.render,
  //$PLACEHOLDER2
enrollments_filters_advanced_client: enrollments_filters_advanced_client.render,
admin_dashboard_client: admin_dashboard_client.render,
student_charges_client: student_charges_client.render,
lessongroup_mutuality_certificates_client: lessongroup_mutuality_certificates_client.render,
mutuality_certificate_config_client: mutuality_certificate_config_client.render,
student_start_links_client: student_start_links_client.render,
config_student_links_client: config_student_links_client.render,
config_teacher_links_client: config_teacher_links_client.render,
config_overview_client: config_overview_client.render,
  finance_payments_overview_client: finance_payments_overview_client.render,
  config_public_enrollments_client: config_public_enrollments_client.render,
  third_party_seller_students_client: third_party_seller_students_client.render,
  student_start_messages_client: student_start_messages_client.render,
  student_start_evaluations_client: student_start_evaluations_client.render,
  student_start_absences_client: student_start_absences_client.render,
  student_start_lessons_notes_client: student_start_lessons_notes_client.render,
  third_party_seller_edit_client: third_party_seller_edit_client.render,
  third_party_sellers_client: third_party_sellers_client.render,
  student_merge_client: student_merge_client.render,
  student_direct_debit_mandates_client:
    student_direct_debit_mandates_client.render,
  config_invoice_pdf_client: config_invoice_pdf_client.render,
  config_evaluation_pdf_client: config_evaluation_pdf_client.render,
  evaluation_missing_list_client: evaluation_missing_list_client.render,
  reenrollment_batches_client: reenrollment_batches_client.render,
  audit_log_overview_client: audit_log_overview_client.render,
  payment_detail_client: payment_detail_client.render,
  evaluation_list_client: evaluation_list_client.render,
  evaluation_template_client: evaluation_template_client.render,
  evaluation_templates_list_client: evaluation_templates_list_client.render,
  failed_enrollment_requests_client: failed_enrollment_requests_client.render,
  lessongroup_questions_edit_client: lessongroup_questions_edit_client.render,
  payment_schemes_client: payment_schemes_client.render,
  lessongroup_questions_client: lessongroup_questions_client.render,
  waitinglist_admin_lessongroup_client:
    waitinglist_admin_lessongroup_client.render,
  waitinglist_student_client: waitinglist_student_client.render,
  waitinglist_admin_client: waitinglist_admin_client.render,
  statistics_enrollments_client: statistics_enrollments_client.render,
  reset_password_client: reset_password_client.render,
  login_client: login_client.render,
  config_mollie_client: config_mollie_client.render,
  config_schoolconfig_client: config_schoolconfig_client.render,
  lessons_now_or_soon_client: lessons_now_or_soon_client.render,
  lesson_statistics_client: lesson_statistics_client.render,
  profile_client: profile_client.render,
  emailsettings_client: emailsettings_client.render,
  welcome_client: welcome_client.render,
  help_client: help_client.render,
  teacher_edit_client: teacher_edit_client.render,
  invoicesToReimburse_client: invoicesToReimburse_client.render,
  student_advanced_client: student_advanced_client.render,
  lessongroup_lessondata_client: lessongroup_lessondata_client.render,
  evaluation_edit_client: evaluation_edit_client.render,
  site_edit_client: site_edit_client.render,
  lessongroup_general_client: lessongroup_general_client.render,
  student_list_client: student_list_client.render,
  roomedit_client: roomedit_client.render,
  tenantinvoices_client: tenantinvoices_client.render,
  config_instruments_client: config_instruments_client.render,
  adminaccounts_client: adminaccounts_client.render,
  studentedit_client: studentedit_client.render,
  search_client: search_client.render,
  periodsconfig_client: periodsconfig_client.render,
  payments_overview_periodic_client: payments_overview_periodic_client.render,
  payinvoice_client: payinvoice_client.render,
  payments_overview_non_periodic_client:
    payments_overview_non_periodic_client.render,
  finance_invoices_client: finance_invoices_client.render,
  deletestudent_client: deletestudent_client.render,
  student_financial_client: student_financial_client.render,
  public_new_enrollment_client: public_new_enrollment_client.render,
  invoicedetails_client: invoicedetails_client.render,
  config_financial_client: config_financial_client.render,
  config_formulas_client: config_formulas_client.render,
  student_profile_client: student_profile_client.render,
  yearcalendar_client: yearcalendar_client.render,
  student_start_client: student_start_client.render,
  reenroll_invitation_client: reenroll_invitation_client.render,
  reenrollments_client: reenrollments_client.render,
  roomplanning_client: roomplanning_client.render,
  studentoverview_client: studentoverview_client.render,
  teacher_lessonroster_client: teacher_lessonroster_client.render,
  teacher_students_client: teacher_students_client.render,
  planning_client: planning_client.render,
  approve_enrollment_request_client: approve_enrollment_request_client.render,
  notes_client: notes_client.render,
  messages_client: messages_client.render,
  erroremails_client: erroremails_client.render,
  editevent_client: editevent_client.render,
  absences_to_approve_list_client: absences_to_approve_list_client.render,
  editmessageonstudentprofiles_client:
    editmessageonstudentprofiles_client.render,
  groupmessage_client: groupmessage_client.render,
  groupmessage_teacher_client: groupmessage_client.renderTeachers,
});

export type clientcomponents = ClientComponents.ClientComponentsExport<
  typeof client
>;
